<script lang="ts">
  import ModuleAbonnement from '@/generated/modules/ModuleAbonnement.vue';
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  extends: ModuleAbonnement
})

</script>
